import * as turf from '@turf/turf';

const polygonDistance = (first, second) => {
    if (!turf.booleanDisjoint(first, second)) return 0;

    const firstLines = turf.flatten(turf.polygonToLine(first)).features;
    const secondLines = turf.flatten(turf.polygonToLine(second)).features;
    let distance = Infinity;
    const measure = (polygon, lines) => turf.coordEach(polygon, coordinate => {
        lines.forEach(line => {
            distance = Math.min(distance, turf.pointToLineDistance(coordinate, line, { units: 'meters' }));
        });
    });
    measure(first, secondLines);
    measure(second, firstLines);
    return distance;
};

export const getSuggestedMergeSize = (polygons) => {
    if (!Array.isArray(polygons) || polygons.length < 2 || polygons.some(polygon => !polygon || !polygon.geometry ||
        !['Polygon', 'MultiPolygon'].includes(polygon.geometry.type))) return null;

    try {
        const nearest = polygons.map(() => Infinity);
        for (let first = 0; first < polygons.length; first++) {
            for (let second = first + 1; second < polygons.length; second++) {
                const distance = polygonDistance(polygons[first], polygons[second]);
                nearest[first] = Math.min(nearest[first], distance);
                nearest[second] = Math.min(nearest[second], distance);
            }
        }
        const distance = Math.max(...nearest);
        // Discard submicrometer coordinate noise before rounding up to meters.
        return Number.isFinite(distance) ? Math.ceil(Number((distance + 3).toFixed(6))) : null;
    } catch (error) {
        return null;
    }
};
